<template>
  <el-dialog
    v-drag
    v-loading="loading"
    :visible.sync="dialogVisible"
    width="1200px"
    :show-close="true"
    :append-to-body="true"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :before-close="cancel"
    top="5vh"
  >
    <span slot="title">
      发送美国
      <span v-if="rowData.sendSupplierOn" class="tips"> 多次发送 </span>
    </span>
    <div class="content">
      <div style="width: 49%">
        <el-form
          ref="form"
          class="form"
          :model="form"
          :rules="rules"
          label-position="top"
        >
          <el-form-item prop="clearenceCode" label="清关行">
            <div style="display: flex">
              <el-select
                v-model="form.clearenceCode"
                placeholder="请选择"
                :disabled="rowData.sendSupplierOn"
                style="width: calc(100% - 110px)"
                @change="change"
              >
                <el-option
                  v-for="item in options"
                  :key="item.code"
                  :label="item.code"
                  :value="item.code"
                ></el-option>
              </el-select>
              <el-button
                style="margin-left: 12px"
                type="primary"
                @click="dialogVisible1 = true"
              >管理清关行</el-button
              >
            </div>
          </el-form-item>
          <el-form-item label="Email To" prop="receiver">
            <el-input
              v-model="form.receiver"
              disabled
              placeholder="请输入收件人"
            ></el-input>
          </el-form-item>
          <el-form-item label="Cc" prop="cc">
            <el-input
              v-model="form.cc"
              disabled
              placeholder="请输入抄送人"
            ></el-input>
          </el-form-item>
          <el-form-item label="主题" prop="subject">
            <el-input
              v-model="form.subject"
              :disabled="rowData.sendSupplierOn"
              type="textarea"
              placeholder="请输入主题"
            ></el-input>
          </el-form-item>
          <el-form-item label="正文" prop="content">
            <vue-editor ref="editor" v-model="form.content"></vue-editor>
          </el-form-item>
        </el-form>
      </div>
      <div style="width: 49%">
        <BaseTable
          :height="728"
          :tableData="tableData"
          :isPager="false"
          :loading="false"
          @handleSelectionChange="handleSelectionChange"
        >
          <div slot="opt" slot-scope="row" class="optbtn">
            <div title="查看" class="btn" @click="check(row.scope)">
              <i class="el-icon-zoom-in"></i>
            </div>
            <div title="下载" class="btn" @click="download(row.scope)">
              <i class="el-icon-download" />
            </div>
          </div>
        </BaseTable>
      </div>
    </div>
    <span slot="footer" class="footers">
      <div class="cancel flex_c_c" @click="cancel">取 消</div>
      <div class="ok flex_c_c" @click="ok('form')">确 定</div>
    </span>
    <ClearenceTplDialog
      :dialogVisible="dialogVisible1"
      :options="options"
      @cancel="dialogVisible1 = false"
      @ok="
        getList();
        dialogVisible1 = false;
      "
    ></ClearenceTplDialog>
  </el-dialog>
</template>
<script>
import { supTemplateList, sendEmail, getMBLFileList, downLoadMBLFile } from '@/api/bill'
import { VueEditor } from 'vue2-editor'
const BaseTable = () => import('@/components/table/BaseTable')
import ClearenceTplDialog from './ClearenceTplDialog'
import dayjs from 'dayjs'
export default {
  components: { VueEditor, BaseTable, ClearenceTplDialog },
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    },
    rowData: {
      type: Object,
      default: function() {
        return {}
      }
    }
  },
  data() {
    return {
      form: {
        clearenceCode: '',
        receiver: '',
        cc: '',
        subject: '',
        content: '',
        fileIds: []
      },
      rules: {
        clearenceCode: [
          { required: true, message: '请选择清关行全称', trigger: 'change' }
        ],
        subject: [{ required: true, message: '请输入主题', trigger: 'blur' }],
        content: [{ required: true, message: '请输入内容', trigger: 'blur' }]
      },
      dialogVisible1: false,
      options: [],
      tableData: {
        fileds: [
          {
            filed: 'fileName',
            label: '文件名',
            width: ''
          },
          {
            filed: 'typeName',
            label: '文件类型',
            width: ''
          },
          {
            filed: 'createdOn',
            label: '上传时间',
            width: ''
          },
          {
            filed: 'createdName',
            label: '上传人',
            width: ''
          },
          {
            filed: 'opt',
            label: '操作',
            width: '120',
            isCustom: true
          }
        ],
        columns: [],
        total: 0,
        mutiCheck: true
      },
      selections: [],
      loading: false
    }
  },
  watch: {
    async dialogVisible(val) {
      if (val) {
        this.getList()
        this.getFileList()
        this.selections = []
        this.form = {
          clearenceCode: '',
          receiver: '',
          cc: '',
          subject: '',
          content: '',
          fileIds: []
        }
        if (this.rowData.sendSupplierOn) {
          this.form.clearenceCode = this.rowData.clearenceSupplier
          this.form.subject = this.rowData.originSubject
        } else {
          this.form.subject = `${dayjs(new Date()).format('YYYY/MM/DD')} ${
            this.rowData.isInland ? 'ANKEY海铁只清关' : 'ANKEY只清关'
          } MBL#:${this.rowData.mblNo} ${
            this.rowData.mblNo !== this.rowData.blNo
              ? `HBL#:${this.rowData.blNo}`
              : ''
          } ${
            this.rowData.containerNumber
              ? `CTNR#:${this.rowData.containerNumber}`
              : ''
          } CTNS:${this.rowData.qty} ${this.rowData.originHarborCode}-${
            this.rowData.destinationHarborCode
          } ${this.rowData.containerType} ETD:${dayjs(this.rowData.etd).format(
            'M/DD'
          )} ETA:${dayjs(this.rowData.eta).format('MM/DD')}`
        }
        this.form.content =
          '<p>Dear all,</p ><br/><p>请查收清关资料，麻烦先提供7501+DO，谢谢~</p ><br/>'
      }
    }
  },
  methods: {
    async getFileList() {
      try {
        const res = await getMBLFileList({
          mblId: this.rowData.mblId
        })
        if (res.success) {
          this.tableData.columns = res.data
        } else {
          this.$message.error(res.errorMessage)
        }
      } catch (error) {
        console.log(error)
      }
    },
    async getList() {
      try {
        const res = await supTemplateList()
        if (res.success) {
          this.options = res.data.map((item, i) => {
            return {
              ...item,
              id: i + 1
            }
          })
          if (this.form.clearenceCode) {
            const item = this.options.find(
              (item) => item.code === this.form.clearenceCode
            )
            this.form.cc = item.cc
            this.form.receiver = item.receiver
          }
        } else {
          this.$message.error(res.errorMessage)
        }
      } catch (error) {
        console.log(error)
      }
    },
    change() {
      const item = this.options.find(
        (item) => item.code === this.form.clearenceCode
      )
      if (item) {
        this.form.receiver = item.receiver
        this.form.cc = item.cc
        //  this.form.receiver = '562533246@qq.com'
        // this.form.cc = ''
      } else {
        this.form.receiver = ''
        this.form.cc = ''
      }
    },
    check(item) {
      const suffix = item.fileName.slice(
        item.fileName.lastIndexOf('.') + 1,
        item.fileName.length
      )
      const { fileGuid } = item
      if (
        suffix.toLowerCase() === 'jpg' ||
        suffix.toLowerCase() === 'jpeg' ||
        suffix.toLowerCase() === 'png'
      ) {
        // window.open(
        //   `/api/SystemFile/preview?guid=${fileGuid}`
        // )
        this.$viewerApi({
          images: [`/api/SystemFile/preview?guid=${fileGuid}`]
        })
      } else if (suffix.toLowerCase() === 'pdf') {
        window.open(`/api/SystemFile/preview?guid=${fileGuid}`)
      } else {
        this.$message.error('暂时只支持图片和PDF查看')
      }
    },
    async download(v) {
      try {
        const res = await downLoadMBLFile({ guid: v.fileGuid })
        if (res) {
          const elink = document.createElement('a')
          elink.style.display = 'none'
          elink.href = res
          elink.type = 'download'
          document.body.appendChild(elink)
          elink.click()
          URL.revokeObjectURL(elink.href)
          document.body.removeChild(elink)
        }
        console.log(res)
      } catch (error) {
        console.log(error)
      }
    },
    // download(v) {
    //   const elink = document.createElement('a')
    //   elink.style.display = 'none'
    //   elink.href = `/api/SystemFile/downLoadFile?guid=${v.fileGuid}`
    //   document.body.appendChild(elink)
    //   elink.click()
    //   URL.revokeObjectURL(elink.href)
    //   document.body.removeChild(elink)
    // },
    cancel() {
      this.$refs['form']?.resetFields()
      this.$emit('cancel')
    },
    ok(formName) {
      this.$refs[formName].validate(async(valid) => {
        if (valid) {
          try {
            this.loading = true
            const res = await sendEmail({
              clearenceCode: this.form.clearenceCode,
              id: this.rowData.id,
              subject: this.form.subject,
              content: this.form.content,
              fileIds: this.selections.map((a) => a.id)
            })
            this.loading = false
            if (res.success) {
              this.$message.success('发送成功')
              this.$emit('ok')
            } else {
              this.$message.error(res.errorMessage)
            }
          } catch (error) {
            console.log(error)
          }
        }
      })
    },
    handleSelectionChange(items) {
      this.selections = items
    }
  }
}
</script>
<style lang="less" scoped>
.tips {
  width: 60px;
  height: 20px;
  display: inline-block;
  background: #f0ead1;
  border-radius: 4px 4px 4px 4px;
  text-align: center;
  line-height: 20px;
  font-family: Microsoft YaHei UI, Microsoft YaHei UI;
  font-weight: 400;
  font-size: 12px;
  color: #aa9a50;
}
.content {
  width: calc(100% - 80px);
  height: auto;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  .optbtn {
    display: flex;
    justify-content: space-around;
  }
  .btn {
    display: flex;
    align-items: center;
    font-size: 12px;
    font-family: Microsoft YaHei-Regular, Microsoft YaHei;
    font-weight: 400;
    color: rgb(18, 88, 188);
    cursor: pointer;
    img {
      margin-right: 4px;
    }
    i {
      font-size: 18px;
      margin-right: 4px;
    }
  }
}
/deep/ .el-dialog__body {
  padding: 20px 20px;
}
.footers {
  width: 100%;
  display: flex;
  justify-content: center;
  .cancel {
    width: 120px;
    height: 40px;
    background: #eeeeee;
    border-radius: 4px 4px 4px 4px;
    font-size: 14px;
    font-family: Microsoft YaHei-Regular, Microsoft YaHei;
    font-weight: 400;
    color: #999999;
    margin-right: 16px;
    cursor: pointer;
  }
  .ok {
    width: 120px;
    height: 40px;
    background: rgb(18, 88, 188);
    border-radius: 4px 4px 4px 4px;
    font-size: 14px;
    cursor: pointer;
    font-family: Microsoft YaHei-Regular, Microsoft YaHei;
    font-weight: 400;
    color: #ffffff;
  }
}
</style>
